import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import ResultsContent from "../components/stores/store-results";
import Layout from "../layout/layout";
export default class StoreView extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let NavList = [
            { Text: 'Search Results', Link: '' }
        ];
        const { stores, selected, updateSelected, mapOptions, clusters } = this.props;
        return (React.createElement(Layout, null,
            React.createElement("div", { className: "main-search-result" },
                React.createElement(Breadcrumb, { NavList: NavList }),
                React.createElement("h5", { className: "product-warning" }, "Please contact the store to confirm availability. A retailer may sell out of any product at any time."),
                React.createElement("h1", null,
                    this.props.name,
                    " ",
                    React.createElement("span", null,
                        this.props.stores.length,
                        " Stores")),
                React.createElement("div", { className: "mobile-filter-toggle" },
                    React.createElement("div", { className: !this.props.toggleMobile ? "active" : "", onClick: () => this.props.updateToggle(false) }, "List"),
                    React.createElement("div", { className: this.props.toggleMobile ? "active" : "", onClick: () => this.props.updateToggle(true) }, "Map")),
                React.createElement("div", { className: !this.props.toggleMobile ? "list-view" : "map-view" },
                    React.createElement(ResultsContent, { getLocation: this.props.getLocation, stores: stores, selected: selected, mapOptions: mapOptions, clusters: clusters, updateSelected: updateSelected, handleMapChange: this.props.handleMapChange, updateAddressText: this.props.updateAddressText, MarkerClick: this.props.MarkerClick, clusterMarkerClick: this.props.clusterMarkerClick })))));
    }
}
;
//# sourceMappingURL=stores.js.map